module.exports = __webpack_public_path__ + "686c4572707b9139078ff2f766988e01.jpg";